import React, { Fragment, useContext } from "react";

import Dropdown from "./components/Dropdown";
// import HelpSection from "./components/HelpSection";
import EligibilityCriteria from "./components/EligibilityCriteria";
import CertificateSample from "./components/CertificateSample";
import NeedHelp from "./components/NeedHelp";
import CommitCodeEthic from "./components/CommitCodeEthic";
import Categories from "./components/Categories";
import MembershipBenefits from "./components/MembershipBenefits";
import EthicsCode from "./components/EthicCodes";
import { AuthContext } from "../../Contexts/AuthContext";

const InternetIcon = "/assets/services/2/coreValueDetail/1.png";
const MapIcon = "/assets/services/2/coreValueDetail/2.png";
const MonarchIcon = "/assets/services/2/coreValueDetail/3.png";
const ProfitIcon = "/assets/services/2/coreValueDetail/4.png";


const imagePath = "/assets/services/2/hero.jpg";

const icon1 = "/assets/services/2/1.png";
const icon2 = "/assets/services/2/2.png";
const icon3 = "/assets/services/2/3.png";
const icon4 = "/assets/services/2/4.png";
const icon5 = "/assets/services/2/5.png";
const icon6 = "/assets/services/2/6.png";
const icon7 = "/assets/services/2/7.png";
const icon8 = "/assets/services/2/8.png";

const gymFacilities = [
    {
        id: 1,
        title: "Facility Standards & Safety",
        content: "Maintain a high level of professional knowledge and skills through continuous learning. Deliver services that are safe, effective, and align with the latest industry standards and best practices.",
    },
    {
        id: 2,
        title: "Qualified & Certified Staff",
        content: "All trainers and staff must hold current, recognized certifications relevant to their field. Continuous professional development is encouraged to ensure knowledge is up-to-date.",
    },
    {
        id: 3,
        title: "Client-Centered Services",
        content: "Offer programs tailored to individual client needs, fitness levels, and health considerations. Avoid offering medical or therapeutic advice unless qualified and legally permitted to do so.",
    },
    {
        id: 4,
        title: "Confidentiality & Privacy",
        content: "Protect client data, personal information, and training records. Obtain written consent before sharing client photos, testimonials, or personal achievements.",
    },
    {
        id: 5,
        title: "Honesty & Transparency",
        content: "Conduct all professional interactions with integrity. Be truthful about your qualifications, services, and pricing, and avoid making false or exaggerated claims.",
    },
    {
        id: 6,
        title: "Professional Boundaries",
        content: "Establish and maintain clear, appropriate boundaries in all client relationships. Avoid dual relationships that could impair professional judgment or exploit the client.",
    },
    {
        id: 7,
        title: "Inclusively & Respect",
        content: "Treat all clients with respect, regardless of their background, culture, gender, age, or beliefs. Be mindful of and sensitive to individual differences when delivering services.",
    },
    {
        id: 8,
        title: "Ethical Marketing & Advertising",
        content: "Market services and credentials in an honest and non-deceptive manner. Avoid misleading claims or tactics that could pressure potential clients into a purchase.",
    },
    {
        id: 9,
        title: "Operational Excellence",
        content: "Maintain a clean, professional appearance and good personal hygiene. This reflects respect for clients and the profession, and contributes to a professional environment.",
    },
    {
        id: 10,
        title: "Legal & Regulatory Compliance",
        content: "Comply with all relevant local, state, and national laws and regulations governing your profession. This includes licensing, certification requirements, and business practices.",
    },
];

const faqData = [
    {
        id: 1,
        title: "1. Professional Competence",
        content:
            "Maintain a high level of professional knowledge and skills through continuous learning. Deliver services that are safe, effective, and align with the latest industry standards and best practices.",
    },
    {
        id: 2,
        title: "2. Honesty & Transparency",
        content:
            "Conduct all professional interactions with integrity. Be truthful about your qualifications, services, and pricing, and avoid making false or exaggerated claims.",
    },
    {
        id: 3,
        title: "3. Practice Within Scope",
        content:
            "Members must only provide services for which they are qualified and refer clients to appropriate experts when necessary. A fitness trainer should not prescribe medical diets or diagnose injuries unless additionally qualified.",
    },
    {
        id: 4,
        title: "4. Client-Centered Care",
        content:
            "Every service should be tailored to the unique needs, goals, and safety of each client. Designing programs based on client fitness levels, health history, and cultural considerations.",
    },
    {
        id: 5,
        title: "5. Confidentiality & Data Protection",
        content:
            "Protect client information and maintain strict confidentiality. All personal data, health history, and session details must be stored securely and used only with explicit consent.",
    },
    {
        id: 6,
        title: "6. Maintaining Professional Boundaries",
        content:
            "Establish and maintain clear, appropriate boundaries in all client relationships. Avoid dual relationships that could impair professional judgment or exploit the client.",
    },
    {
        id: 7,
        title: "7. Safety & Risk Management",
        content:
            "Prioritize the safety of clients at all times. This includes conducting thorough risk assessments, ensuring equipment is well-maintained, and having clear emergency procedures in place.",
    },
    {
        id: 8,
        title: "8. Respect for Cultural & Individual Diversity",
        content:
            "Treat all clients with respect, regardless of their background, culture, gender, age, or beliefs. Be mindful of and sensitive to individual differences when delivering services.",
    },
    {
        id: 9,
        title: "9. Effective Communication",
        content:
            "Communicate clearly and respectfully with clients, colleagues, and other professionals. Ensure clients understand the nature of services, risks, and expected outcomes.",
    },
    {
        id: 10,
        title: "10. Ethical Marketing & Advertising",
        content:
            "Market services and credentials in an honest and non-deceptive manner. Avoid misleading claims or tactics that could pressure potential clients into a purchase.",
    },
    {
        id: 11,
        title: "11. Commitment to Continued Learning",
        content:
            "Stay current with new research, techniques, and developments in your field. Actively seek out professional development opportunities to enhance your skills and knowledge.",
    },
    {
        id: 12,
        title: "12. Punctuality & Professional Conduct",
        content:
            "Adhere to scheduled appointments and professional commitments. Present yourself in a professional manner and maintain a high standard of conduct at all times.",
    },
    {
        id: 13,
        title: "13. Appearance & Hygiene",
        content:
            "Maintain a clean, professional appearance and good personal hygiene. This reflects respect for clients and the profession, and contributes to a professional environment.",
    },
    {
        id: 14,
        title: "14. Conflict Resolution",
        content:
            "Address conflicts or grievances with clients or colleagues in a constructive and professional manner. Seek a fair and equitable resolution that prioritizes the well-being of all parties involved.",
    },
    {
        id: 15,
        title: "15. Legal & Regulatory Compliance",
        content:
            "Comply with all relevant local, state, and national laws and regulations governing your profession. This includes licensing, certification requirements, and business practices.",
    },
];

const cardData = [
    {
        id: 1,
        title: "National Level Recognition & Credibility",
        description:
            "Stand out as a trusted and approved fitness facility recognised across India.",
        icon: icon1,
        shape:
            "rounded-tl-[20px] rounded-tr-[40px] rounded-bl-[40px] rounded-br-[40px]",
    },
    {
        id: 2,
        title: "Certificate of Affiliation & Digital Seal",
        description:
            "Receive an official certificate and digital seal for use in branding, marketing, and promotions.",
        icon: icon2,
        shape:
            "rounded-tl-[40px] rounded-tr-[20px] rounded-bl-[40px] rounded-br-[40px]",
    },
    {
        id: 3,
        title: "Listing in the FWPI Approved Facilities Directory",
        description:
            "Get featured in a nationwide directory, making it easier for potential clients to discover your facility.",
        icon: icon3,
        shape:
            "rounded-tl-[40px] rounded-tr-[40px] rounded-bl-[20px] rounded-br-[40px]",
    },
    {
        id: 4,
        title: "Special Discounts on Courses & Certifications",
        description:
            "Access exclusive rates on fitness, wellness, and nutrition education programs for you and your team.",
        icon: icon4,
        shape:
            "rounded-tl-[40px] rounded-tr-[40px] rounded-bl-[40px] rounded-br-[20px]",
    },
    {
        id: 5,
        title: "Partner Supplement & Equipment Offers",
        description:
            "Avail discounted prices on top supplement brands and high-quality fitness equipment through FWPI partners.",
        icon: icon5,
        shape:
            "rounded-tl-[20px] rounded-tr-[40px] rounded-bl-[40px] rounded-br-[40px]",
    },
    {
        id: 6,
        title: "Free Gym Setup Consultancy",
        description:
            "Receive expert guidance on gym design, layout, and management strategies.",
        icon: icon6,
        shape:
            "rounded-tl-[40px] rounded-tr-[20px] rounded-bl-[40px] rounded-br-[40px]",
    },
    {
        id: 7,
        title: "Eligible for Approved training provider",
        description:
            "Opportunity to become an FWPI-approved education or training center.",
        icon: icon7,
        shape:
            "rounded-tl-[40px] rounded-tr-[40px] rounded-bl-[20px] rounded-br-[40px]",
    },
    {
        id: 8,
        title: "Boost Client Trust",
        description:
            "Showcase your affiliation to attract more health-conscious and quality-focused customers.",
        icon: icon8,
        shape:
            "rounded-tl-[40px] rounded-tr-[40px] rounded-bl-[40px] rounded-br-[20px]",
    },
];
const categories = [
    "Gym Facility",
    "Personal Training Studios",
    "Yoga & Pilates Studios",
    "Functional Training Centres",
    "Wellness Clinics & Fitness Spaces",
    "Dance Fitness Studio",
];

const aboutMember = [
    {
        title: "Legal Registration",
        description: "Must be a registered business entity.",
        icon: InternetIcon,
    },
    {
        title: "Valid ID Proof of Owner",
        description: "Copy of PAN Card and Aadhaar Card.",
        icon: MapIcon,
    },
    {
        title: "Latest Utility Bill",
        description: "Electricity bill for verification of operational status.",
        icon: MonarchIcon,
    },
    {
        title: "Ownership or Lease Proof",
        description:
            "Provide rent/lease agreement for rented property or ownership documents for owned property.",
        icon: ProfitIcon,
    },
];

const ElevateStandardServices = () => {

    const { token, setIsLoginModal } = useContext(AuthContext);
    return (
        <Fragment>
            <section className="w-full bg-gradient-radial pt-32 pb-12 lg:py-40">
                <div className="container mx-auto px-4 lg:px-15 flex flex-col-reverse lg:flex-row items-center gap-10">
                    <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start">
                        <img className="w-full h-auto object-cover rounded-tl-2xl lg:rounded-tl-2xl rounded-[5rem] md:rounded-[10rem] border-2 border-white" src={imagePath} alt="service-hero-section" />
                    </div>
                    <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left gap-8">
                        <p className="text-lg md:text-xl font-urbanist text-stone-300">
                            FWPI Accreditation for Gyms,<br />Studios, and Wellness Centres
                        </p>
                        <h1 className="text-3xl sm:text-5xl lg:text-5xl font-bold font-urbanist text-white capitalize text-center lg:text-left leading-tight">
                            Elevate Standards- with FWPI Approval
                        </h1>
                        <p className="text-base sm:text-base lg:text-xl font-urbanist font-semibold text-stone-300">
                            Give your fitness facility the recognition it deserves.
                            <br />
                            <br /> FWPI’s Facility Approval Program certifies that your gym,
                            yoga studio, fitness centre, or wellness space adheres to national
                            quality standards, ensures client safety, and promotes ethical
                            business practices.
                        </p>
                    </div>
                </div>
            </section>

            <MembershipBenefits
                title={"FWPI Membership Benefits for Gym Facilities & Studios"}
                description={"As an FWPI-Affiliated Gym or Studio, you will "}
                buttonName={"Join Now"}
                benefits={cardData}
            />

            <Categories
                title={'Why Choose US'}
                description={'Category'}
                tags={categories}
            />

            <section className="bg-gradient-radial">
                <div className="flex justify-center items-center flex-col w-[75%] mx-auto  ">
                    <h2 className="text-3xl md:text-4xl font-semibold mb-2 text-white text-center md:mt-10">
                        How to Apply – FWPI Gym Facilities & Studios Accreditation
                    </h2>
                    <p className="w-[100%] mx-auto text-[14px] md:text-[20px] lg:text-[22px] xl:text-[24px]  font-normal text-neutral-400 mb-2 font-urbanist  italic  leading-[2] tracking-[2%] text-center">
                        Becoming an{" "}
                        <span className="font-bold">
                            {" "}
                            FWPI Approved Gym Facility or Studio{" "}
                        </span>{" "}
                        establishes your commitment to safety, professionalism, and service
                        excellence. Follow the process below to ensure your facility meets
                        the required standards and secures national recognition.
                    </p>
                </div>
                <EligibilityCriteria />
            </section>

            <EthicsCode
                title={`FWPI Gym Facilities & Studios – Code of Ethics`}
                description='All FWPI Accredited Training Providers must uphold the highest standards of integrity, quality, and professionalism in delivering education. This Code of Ethics sets the principles and expectations for maintaining accreditation and protecting the credibility of FWPI-recognised qualifications.'
                items={gymFacilities}
            />

            <CommitCodeEthic
                title={"Commit to Code of Ethics"}
                description={"Commit to Code of Ethics"}
                buttonName={"Apply Now"}
                pathname={!!token ? '/my-profile' : '/gym/create'}
                onClick={() => {
                    if (!token) {
                        setIsLoginModal(true);
                    }
                }}
            />

            <CertificateSample
                imagePath="/assets/services/2/certificate.jpg"
            />

            <NeedHelp />

        </Fragment>
    );
};

export { ElevateStandardServices };
